import { datadogRum } from '@datadog/browser-rum';
import config from '@/config'

function reviewEnvironmentName() {
  return location.hostname.split('.')[1];
}

if (config.env !== 'test') {
  const resp = datadogRum.init({
    applicationId: config.datadogAppId,
    clientToken: config.datadogClientToken,
    site: 'datadoghq.eu',
    service:'online-forms',
    sampleRate: 10,
    trackInteractions: true,
    defaultPrivacyLevel: 'mask',
    env: config.env === 'staging' ? `review-${reviewEnvironmentName()}` : config.env,
    version: process.env.VUE_APP_DEPLOY_RELEASE,
    allowedTracingOrigins: [/.*\.salonized\.com/, /.*\.salonized-staging\.io/,/.*\.salonized\.fml/],
  });

  datadogRum.startSessionReplayRecording();
}
